import { taskAxiosInstance } from "../axiosInstance";
import type {
    TaskComment,
    TaskCommentQuery,
    TaskCommentListResponse,
    CreateTaskCommentInput,
    UpdateTaskCommentInput,
} from "./taskApi";

export const MAX_COMMENT_LENGTH = 250;

export const getTaskComments = async (
    taskId: number,
    query: TaskCommentQuery = {},
): Promise<TaskCommentListResponse> => {
    const params = new URLSearchParams();
    params.set("taskId", taskId.toString());
    if (query.skip !== undefined) params.set("skip", query.skip.toString());
    if (query.take !== undefined) params.set("take", query.take.toString());

    const queryString = params.toString();
    const response = await taskAxiosInstance.get<TaskCommentListResponse>(
        `/task-comments${queryString ? `?${queryString}` : ""}`,
    );

    return response.data;
};

export const getTaskCommentById = async (id: number): Promise<TaskComment> => {
    const response = await taskAxiosInstance.get<TaskComment>(`/task-comments/${id}`);
    return response.data;
};

export const createTaskComment = async (
    taskId: number,
    data: CreateTaskCommentInput,
): Promise<TaskComment> => {
    const response = await taskAxiosInstance.post<TaskComment>("/task-comments", {
        taskId,
        comment: data.comment,
    });

    return response.data;
};

export const updateTaskComment = async (
    id: number,
    data: UpdateTaskCommentInput,
): Promise<TaskComment> => {
    const response = await taskAxiosInstance.patch<TaskComment>(`/task-comments/${id}`, {
        comment: data.comment,
    });

    return response.data;
};

export const deleteTaskComment = async (id: number): Promise<TaskComment> => {
    const response = await taskAxiosInstance.post<TaskComment>(`/task-comments/${id}/delete`);
    return response.data;
};
